import { ProgressBar } from '../../../../shared/components/cards/progress-bar/ProgressBar'
import React from 'react'

interface VisibilityCellProps {
  visibility: number
}

export const VisibilityCell = ({ visibility }: VisibilityCellProps) => {
  return <ProgressBar percent={visibility} toFixed={1} />
}
